import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { Design } from '@/model/document2/page/surface/design/design';

// レイヤー変形(移動・拡大・回転)コマンド
export class TransformLayerCommand implements ICommandBase
{
    private layer! : Layer;

    // Parameter
    private x : number = 0;
    private y : number = 0;
    private width : number = 0;
    private height : number = 0;
    private rotate : number = 0;

    // OldParameter
    private oldX : number = 0;
    private oldY : number = 0;
    private oldWidth : number = 0;
    private oldHeight : number = 0;
    private oldRotate : number = 0;

    private design! : Design;
    private doneCallback! : () => void;

    constructor(layer : Layer, x : number, y : number, width : number, height : number, rotate : number, design : Design, doneCallback : () => void)
    {
        this.layer = layer;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.design = design;
        this.rotate = rotate;
        this.doneCallback = doneCallback;

        // 現在の値を保持
        this.oldX = layer.x;
        this.oldY = layer.y;
        this.oldWidth = layer.width;
        this.oldHeight = layer.height;
        this.oldRotate = layer.rotate;
    }

    public do() : void
    {
        // パラメータ適用
        this.layer.width = this.width;
        this.layer.height = this.height;
        this.layer.rotate = this.rotate;
        this.layer.x = this.x;
        this.layer.y = this.y;

        this.doneCallback();
    }

    public undo() : void
    {
        // 以前のパラメータ適用
        this.layer.width = this.oldWidth;
        this.layer.height = this.oldHeight;
        this.layer.rotate = this.oldRotate;
        this.layer.x = this.oldX;
        this.layer.y = this.oldY;

        // カレントレイヤー再設定
        this.design.currentLayer = this.layer;

        this.doneCallback();
    }

    public redo() : void
    {
        // パラメータ適用
        this.layer.width = this.width;
        this.layer.height = this.height;
        this.layer.rotate = this.rotate;
        this.layer.x = this.x;
        this.layer.y = this.y;

        // カレントレイヤー再設定
        this.design.currentLayer = this.layer;

        this.doneCallback();
    }
}